/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type { ArjSettingsFinancialYear as ArjSettingsFinancialYearType } from '@jira/spa-apps__advanced-roadmaps-financial-year-settings/src/ArjSettingsFinancialYear.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

/**
 * Plans Settings - Financial Year
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyArjSettingsFinancialYear: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ArjSettingsFinancialYearType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-arj-settings-financial-year", jiraSpaEntry: "async-arj-settings-financial-year" */ '@jira/spa-apps__advanced-roadmaps-financial-year-settings/src/ArjSettingsFinancialYear.tsx'
			).then((module) => module.ArjSettingsFinancialYear),
		),
	{ ssr: false },
);

export const ArjSettingsFinancialYear = (): React.JSX.Element => (
	<LazyPage
		Page={LazyArjSettingsFinancialYear}
		pageId="arj-settings-financial-year"
		shouldShowSpinner
	/>
);
